import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { Observable, Subject } from 'rxjs';
import { EmitMonitorList, GetMonitor, MonitorListBo } from './client-monitorlist.model';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ColumnChangeBO, columnWidth } from '../employee/employee.model';
import { GlobalComponent } from 'src/app/global/global.component';
import { CommonApiService } from 'src/app/commonapiservice';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/service/general.service';

import { takeUntil } from 'rxjs/operators';
import { ClientMonitorService } from './client-monitorlist.service';
import { IMyDpOptions } from 'mydatepicker';
import { DateService } from 'src/app/date.service';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-client-monitorlist',
  templateUrl: './client-monitorlist.component.html',
  styleUrls: ['./client-monitorlist.component.scss']
})
export class ClientMonitorlistComponent implements OnInit {

  private onDestroy$: Subject<void> = new Subject<void>();
  monitorListbo: MonitorListBo = new MonitorListBo()
  MonitorDropdownList: any = [];
  @Input() ToMonitor: EmitMonitorList;
  @Output() DataFromMonitor = new EventEmitter<EmitMonitorList>();
  Status: any = 'Active';
  monitordetailsList: any = [];
  statusFilter: any;
  statusList: any = [];
  GetMonitor: GetMonitor = new GetMonitor();
  public data: Observable<DataStateChangeEventArgs>;
  saveTypeStatusList: any = [];
  ColumnArrayMonitor: columnWidth[];
  filterOptions: FilterSettingsModel;
  arraycol: any = [];
  public formatOptions: object;
  public initialPage: object;
  public wrapSettings: TextWrapSettingsModel;
  public typeinitialPage: object;
  @ViewChild('grid') public grid: GridComponent;
  public id: number = 0;
  // formatOptions:object
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  MonitorId: any;

  colors = [
    { label: 'Red', value: 'red' },

    { label: 'Yellow', value: 'yellow' },
    { label: 'Green', value: 'green' },
    { label: 'Blue', value: 'blue' }
  ];

  selectedColor: any
  constructor(
    public global: GlobalComponent,
    public CommonAPI: CommonApiService,
    public http: ClientMonitorService,
    public toasterService: ToastrService,
    public general: GeneralService, public dateservice: DateService, public datepipe: DatePipe) {
    this.data = http;
  }
  ngOnInit(): void {

    this.filterOptions = { type: 'Menu' };
    this.formatOptions = { type: 'datetime', format: 'MM/dd/yyyy' };
    this.wrapSettings = { wrapMode: 'Content' };
    this.initialPage = { pageSizes: ['10', '20', '50', '100', '250'], pageSize: 10 };
    this.typeinitialPage = { pageSize: 10 };
    this.Status = 'Active'
    this.getStatusLov();
    this.getMonitorList();
  }
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    // disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };

  newdates(event, type, name) {
    if (type == "inputchage") {
      if (name == 'date') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.monitorListbo.monitorDate = val1;

        }
      }


    }

    if (type == "datechagned") {
      if (name == 'date') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.monitorListbo.monitorDate = val1;
        }
      }



    }
  }
  SaveOrUpdateMonitor() {
    let url;
    let saveBo = this.monitorListbo;
    if (saveBo.id == '00000000-0000-0000-0000-000000000000') {
      // if (!this.ToMonitor.isClient && this.ToMonitor?.employeeId != null) {
      //   url = "api/EmployeeMonitor/SaveEmployeeMonitor";
      //   this.monitorListbo.employeeId = this.ToMonitor.employeeId
      // }
      // else {
      this.monitorListbo.clientId = this.ToMonitor.clientId
      url = "api/Client/SaveClientColorNote";
      // }
    }
    else {

      this.monitorListbo.clientId = this.ToMonitor.clientId
      url = "api/Client/SaveClientColorNote";

    }

    saveBo.monitorDate = (saveBo.monitorDate != null && saveBo.monitorDate != undefined && saveBo.monitorDate != '' && saveBo.monitorDate != null) ? this.global.getDateTimeString(saveBo.monitorDate) : null;
    saveBo.inActiveDate = (saveBo.inActiveDate != null && saveBo.inActiveDate != undefined && saveBo.inActiveDate != '' && saveBo.inActiveDate != null) ? this.global.getDateTimeString(saveBo.inActiveDate) : null;

    this.CommonAPI.saveorUpdateFunctionwithResponseTypeText(this.monitorListbo, url,).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data) {
        document.getElementById('openMonitorModal1').click();
        if (this.monitorListbo.id == '00000000-0000-0000-0000-000000000000') {
          this.toasterService.success('MonitorList saved successfully!');
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        }
        else {
          this.toasterService.success('MonitorList updated successfully!');
          setTimeout(() => {
            this.toasterService.clear();
          }, 8000);
        }
        this.Status = 'Active'
        this.getStatusLov();
      }
    }, (err: any) => {
      if (err) {
        this.toasterService.error(err, 'Error'), 8000;
        this.monitorListbo.monitorDate = this.datepipe.transform(this.monitorListbo.monitorDate, "MM/dd/yyyy")
        this.monitorListbo.inActiveDate = this.datepipe.transform(this.monitorListbo.inActiveDate, "MM/dd/yyyy")

      }
    })
  }
  getAgencyMonitorListdropdown() {
    this.monitorListbo = new MonitorListBo()
    this.monitorListbo.statusLid = this.statusList.filter(s => s.lovCode == "ACTIVE")[0]?.id;

    this.monitorListbo.monitorDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();

    let url;
    // if (!this.ToMonitor.isClient && this.ToMonitor?.employeeId != null) {
    //   url = "api/MonitorList/GetEmployeeMonitorDropDown?";

    // } else {
    //   url = "api/MonitorList/GetClientMonitorDropDown?";
    // }
    // this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    //   this.MonitorDropdownList = data
    // })
  }
  getMonitorListdetails() {
    this.monitordetailsList = []

    this.GetMonitor.clientId = this.ToMonitor?.clientId;
    this.GetMonitor.StatusLid = (this.statusFilter != '' && this.statusFilter != undefined && this.statusFilter != null) ? this.statusFilter : null;
    this.http.outputValuesClientMonitorDetails(this.GetMonitor)
    this.data
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        this.monitordetailsList = data?.result;
        if (data != null && data?.result?.length >= 15) {
          this.grid.height = "500";
        }
        else {
          this.grid.height = "auto";
        }
        this.ToMonitor.isAdddedClientMonitor = this.monitordetailsList?.some(e => (e.statusName == 'Active' && this.Status == 'Active'))
        this.ToMonitor.isAdddedEmployeeMonitor = false;
        if (this.Status == 'Active') {
          this.DataFromMonitor.emit(this.ToMonitor)
        }
      });

  }
  deletemonitor(id) {
    this.MonitorId = id;
    document.getElementById('OpendeleteModal22').click();
  }
  deletemonitorlist() {
    let params = new URLSearchParams();
    let url;
    // if (!this.ToMonitor.isClient && this.ToMonitor?.employeeId != null) {
    //   url = "api/EmployeeMonitor/deleteEmployeeMonitor?";
    //   params.append("EmployeeMonitorId", this.MonitorId?.toString());
    //   params.append("EmployeeId", this.ToMonitor.employeeId?.toString());
    // }
    // else {
    url = "api/Client/deleteClientMonitor?";
    params.append("ClientMonitorId", this.MonitorId?.toString());
    params.append("ClientId", this.ToMonitor.clientId?.toString());

    this.CommonAPI.DeleteFunctionForDeleteHttp(params, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (data: any) => {
          this.toasterService.success("MonitorList deleted successfully!"), 8000;
          document.getElementById('OpendeleteModal22').click();
          this.getMonitorListdetails();
        },
        (err: any) => {
          this.toasterService.error(err, 'Error'), 8000;
        }
      );
  }
  closemodal() {
    // this.monitorListbo = new MonitorListBo()
    document.getElementById('openMonitorModal1').click();
  }
  Inactive: any = '';
  monitorstatusListChange() {
    console.log(this.Status, "Status==========");

    this.Inactive = this.statusList.filter(s => s.lovCode == "INACTIVE" && s.id == this.monitorListbo.statusLid)[0]?.lovCode;
    console.log(this.Inactive, "inactive==========");
    if (this.Inactive != null && this.Inactive != "" && this.Inactive != undefined) {
      if (this.monitorListbo.inActiveDate != null && this.monitorListbo.inActiveDate != '') {

      }
      else {
        this.monitorListbo.inActiveDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();

      }
      // this.monitorListbo.monitorDate = ''
    }
    else {
      if (this.monitorListbo.monitorDate != null && this.monitorListbo.monitorDate != '') {

      }
      else {
        this.monitorListbo.monitorDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();

      }
     // this.monitorListbo.inActiveDate = ''
    }

  }


  editmonitorlist(data) {
    this.monitorListbo = new MonitorListBo()

    this.monitorListbo.id = data.id
    this.monitorListbo.clientMonitorId = data.id
    this.monitorListbo.monitorId = data.monitorId?.toString();
    this.monitorListbo.notes = data?.notes;
    this.monitorListbo.statusLid = data.statusLid;
    this.monitorListbo.monitorDate = this.datepipe.transform(data.monitorDate, "MM/dd/yyyy")
    this.monitorListbo.inActiveDate = this.datepipe.transform(data.inActiveDate, "MM/dd/yyyy")
    console.log(this.monitorListbo.monitorDate, "this.monitorListbo.monitorDate");
    this.Inactive = this.statusList.filter(s => s.lovCode == "INACTIVE" && s.id == this.monitorListbo.statusLid)[0]?.lovCode;
    document.getElementById('openMonitorModal1').click();
  }
  getStatusLov() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "STATUS");
    this.CommonAPI.getDropDownList("STATUS", params, url, "LovDropDown").then((data: any) => {
      this.statusList = data
      this.statusFilter = (this.Status == 'All') ? null : data.filter(e => e.lovName == this.Status)[0].id;
      this.getMonitorListdetails();
    }, err => {
    })
  }
  public dataStateChangeNotes(state): void {
    let val = (state.action.requestType).toString();
    if (val != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.GetMonitor.orderColumn = state.sorted[0].name;
        this.GetMonitor.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (val == "filtering" && state.action.action != "clearFilter") {
      if (this.GetMonitor.type == "number") {
        this.GetMonitor.value = state.action.currentFilterObject.value.toString();
        this.GetMonitor.field = state.action.currentFilterObject.field;
      }
      if (this.GetMonitor.type == "date") {
        this.GetMonitor.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
        this.GetMonitor.field = state.action.currentFilterObject.field;
      }
      else {
        this.GetMonitor.value = state.action.currentFilterObject.value;
        this.GetMonitor.field = state.action.currentFilterObject.field;
      }
      this.GetMonitor.matchCase = state.action.currentFilterObject.matchCase;
      this.GetMonitor.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (val == "filtering" && state.action.action == "clearFilter") {
        this.GetMonitor.field = "monitorName";
        this.GetMonitor.matchCase = false;
        this.GetMonitor.operator = "contains";
        this.GetMonitor.value = "";
        this.GetMonitor.type = "string"
      }
    }
    if (val == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].AssigMonitor.Pagesize != state.take) {
          this.arraycol[0].AssigMonitor.Pagesize = state.take
          this.SaveColumnwidth();
        }
      }
    }
    this.getMonitorListdetails()
  }
  public onActionCompleteNotes(args) {
    this.GetMonitor.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.GetMonitor.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
      this.GetMonitor.type = args.columnType
    }
  }
  onResizeNotes(args) {
    if (this.ColumnArrayMonitor != undefined && this.ColumnArrayMonitor != null) {
      const column = this.grid.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.ColumnArrayMonitor?.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      this.SaveColumnwidth();
    }
  }
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArrayMonitor = this.arraycol[0].AssigMonitor.Columns;
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }
    if (this.grid != undefined) {
      this.grid.pageSettings.pageSize = this.arraycol[0].AssigMonitor.Pagesize;
      this.ColumnArrayMonitor.forEach(element => {
        if (element.column == 'Monitor Name') {
          const column1 = this.grid.getColumnByField('monitorName');
          column1.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'Notes') {
          const column1 = this.grid.getColumnByField('notes');
          column1.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'Status') {
          const column1 = this.grid.getColumnByField('statusName');
          column1.width = element.width;
          this.grid.refreshHeader();
        }
        if (element.column == 'Actions') {
          const column1 = this.grid.getColumnByUid('action');
          column1.width = element.width;
          this.grid.refreshHeader();
        }
      });
    }
    let column1 = "statusName";
    let column2 = "Action";
    if (this.ToMonitor.isView) {
      this.grid.hideColumns(column1);
      this.grid.hideColumns(column2);

    } else {
      this.grid.showColumns(column1);
      this.grid.showColumns(column2);
    }

  }
  SaveColumnwidth() {
    this.arraycol[0].AssigMonitor.Columns = this.ColumnArrayMonitor;
    this.arraycol[0].Client_Evaluation_Notes.Pagesize = this.grid.pageSettings.pageSize;
    this.columnchange.userid = parseInt(this.global.userID);
    this.columnchange.column = JSON.stringify(this.arraycol);
    this.columnchange.id = this.id;
    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    let url = "api/ColumnChange/Savewidth?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getColumnwidth();
    });
  }
  closeDelMonitorModal() {
    document.getElementById('OpendeleteModal22').click();
  }


  monitorList: any = []
  getMonitorList() {
    let myparams = new URLSearchParams();
    //  myparams.append("clientId", this.global.clientId.toString());
    let url = "api/Client/GetMonitors?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(myparams, url).subscribe(
      (data) => {
        this.monitorList = data;
        this.monitorList.forEach(element => {
          element.label = element.colorName
          element.value = element.colorName
          element.colorandnotes = element.colorandnotes
        });
        //  colors = [
        //   { label: 'Red', value: 'red' },

        //   { label: 'Yellow', value: 'yellow' },
        //   { label: 'Green', value: 'green' },
        //   { label: 'Blue', value: 'blue' }
        // ];
      })
  }


  ChangeColornotes() {
    console.log('Selected item:', this.monitorList.find(item => item.monitorId === this.monitorListbo.monitorId));

    if (this.monitorListbo.id == '00000000-0000-0000-0000-000000000000') {
      this.monitorListbo.notes = this.monitorList.filter(m => m.monitorId == this.monitorListbo.monitorId)[0]?.colorNotes
    } else {
      if (this.monitorListbo.notes == null || this.monitorListbo.notes == "" || this.monitorListbo.notes == undefined) {
        this.monitorListbo.notes = this.monitorList.filter(m => m.monitorId == this.selectedColor)[0]?.colorNotes

      }
    }
  }


  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }


}
